import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import GlobalCard from '../../../../components/GlobalCardComponent'

export default function SapResourcecComp() {
      const resources = [
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (13).png"
          width="100%"
          height="100%"
        />
      ),
      title: "Career Pathway Reports",
      description:
        "Psychometric-based insights to pick the right course and country.",
      buttonTitle: "Download Sample",
    },
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (14).png"
          width="100%"
          height="100%"
        />
      ),

      title: "University Shortlisting Tool",
      description: "Find universities matching your profile, budget and goals.",
      buttonTitle: "Try the tool",
    },
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (15).png"
          width="100%"
          height="100%"
        />
      ),

      title: "Country Guides",
      description:
        "USA, UK, Canada, Australia, Europe — costs, visas, scholarships.",
      buttonTitle: "Explore Guides",
    },
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (16).png"
          width="100%"
          height="100%"
        />
      ),

      title: "Scholarship & Funding",
      description: "Curated scholarships and grants across top destinations..",
      buttonTitle: "See scholarship",
    },
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (17).png"
          width="100%"
          height="100%"
        />
      ),

      title: "Timeline Planner",
      description:
        "Month-by-month checklist for tests, applications and visas..",
      buttonTitle: "Get the planner",
    },
    {
      icon: (
        <img
          src="/newdashboard/Saptools/Group 1171282790 (18).png"
          width="100%"
          height="100%"
        />
      ),

      title: "Ask a Counselor",
      description:
        "Quick answers from experts on courses, exams and documents.",
      buttonTitle: "Chat Now",
    },
  ];
  return (
  <>
    <Grid container spacing={4}>
                {resources?.map((item, index) => (
                  <Grid item xs={12} sm={12} md={4} key={index} mt={1}>
                    <GlobalCard
                      height="100%"
                      textAlign="center"
                      hovershadowEffect={true}
                    >
                      <Box display="flex" justifyContent="center">
                        <Box height={55} width={55}>
                          {item.icon}
                        </Box>
                      </Box>
                      <Typography
                        mt={1}
                        fontFamily="Inter"
                        fontWeight={400}
                        fontStyle="normal"
                        fontSize="18px"
                        color="#000000"
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        mt={1}
                        fontFamily="Inter"
                        fontWeight={400}
                        fontStyle="normal"
                        fontSize="12px"
                        color="#313439"
                      >
                        {item.description}
                      </Typography>
  
                      <Button
                        size="small"
                        variant="contained"
                        style={{
                          marginTop: "10px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontStyle: "normal",
                          fontSize: "10px",
                          color: "#FFFFFF",
                          background: "#9D0385",
                          borderRadius: "8px",
                        }}
                      >
                        {item.buttonTitle}
                      </Button>
                    </GlobalCard>
                  </Grid>
                ))}
              </Grid>
  </>
  )
}
